var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Modal from './components/templates/Modal/Modal';
import SignupWelcome from './components/organisms/SignupWelcome';
import { useQueryStringParams } from './businessLogics/hooks';
import { useUserInfo } from './businessLogics/apis';
var Welcome = function (_a) {
    var CPLogger = _a.CPLogger;
    var query = useQueryStringParams();
    var _b = useState(false), isShow = _b[0], setIsShow = _b[1];
    var userInfo = useUserInfo();
    useEffect(function () {
        setIsShow(query.get('welcome') === 'true');
    }, [query.get('welcome')]);
    return (_jsx(_Fragment, { children: userInfo.isSuccess && isShow && (_jsx(Modal, __assign({ isShow: isShow, setIsShow: setIsShow, isFitContent: true, CPLogger: CPLogger }, { children: _jsx(SignupWelcome, { setIsShow: setIsShow, userInfo: userInfo, CPLogger: CPLogger }) }))) }));
};
export default Welcome;
//# sourceMappingURL=Welcome.js.map